import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';

const SkillListPage          = lazy(() => import('src/pages/skills/skill-list-page'));
const SkillDetailPage        = lazy(() => import('src/pages/skills/skill-detail-page'));
const SkillBuilderPage       = lazy(() => import('src/pages/skills/skill-builder'));
const SkillBuilderTopicsPage = lazy(() => import('src/pages/skills/skill-builder-topics-page'));

export const skillRoutes: RouteObject[] = [
  {
    path: 'skills',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <SkillListPage />, index: true },
      { path: ':skillId', element: <SkillDetailPage /> },
      { path: ':skillId/:slug', element: <SkillDetailPage /> },
    ],
  },
  {
    path: 'skill-builder',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <SkillBuilderPage />, index: true },
      { path: ':skillId', element: <SkillBuilderTopicsPage /> },
      { path: ':skillId/:slug', element: <SkillBuilderTopicsPage /> },
    ],
  },
];